import { Button, Link } from 'omakase';
import { FC } from 'react';
import { IconTransfer } from '@tock/icons';
import { ReceiptButtonProps } from 'components/business/receipts/ReceiptActionButtons';

const ReceiptTransferButton: FC<ReceiptButtonProps> = ({ variant = 'button', ...rest }) => {
  return variant === 'button' ? (
    <Button
      variant="basic"
      size="medium"
      iconStart={<IconTransfer />}
      data-testid="transfer-booking"
      fullWidth
      {...rest}
    >
      Transfer
    </Button>
  ) : (
    <Link data-testid="transfer-booking" {...rest}>
      Transfer ownership of reservation
    </Link>
  );
};

export default ReceiptTransferButton;
